import { Pipe, PipeTransform } from '@angular/core';
import { IPreviousChats } from '../models/chat.model';

@Pipe({
  name: 'getRecentContacts'
})
export class GetRecentContactsPipe implements PipeTransform {
  transform(allContacts: IPreviousChats[], slice?: boolean): any {
    const sortContacts = allContacts.sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );
    return slice ? sortContacts.slice(0, 6) : sortContacts;
  }
}
